const trackCondition = {
  templateUrl: '/modules/track-condition/track-condition.html',
  controller: 'TrackConditionController',
};

angular
  .module('track-condition.module', ['ui.router'])
  .component('trackCondition', trackCondition)
  .config(function ($stateProvider) {
      $stateProvider
          .state('track-condition', {
              url: '/track-condition',
              component: 'trackCondition',
              resolve: {
                  auth: function (userService, $state, eventService) {
                      return userService
                          .resolve(['ACCESS_TRACK_CONDITION'])
                          .then(() => {
                          })
                          .catch(() => {
                              eventService.trigger('userservice:unauthorized');
                              $state.go('frontpage');
                          });
                  },
              },
          });
  });
